// Living Portrait — Tesla face animation system.
//
// Module scripts are deferred — DOM is parsed by the time this runs, so we
// don't (and must not) wrap in DOMContentLoaded. Wrapping would miss the event.
//
// `new URL(literal, import.meta.url)` is Parcel 2's officially supported pattern
// for ESM static asset references. The literal path is statically analyzed at
// build time so the asset gets bundled; the runtime returns a real URL string.
var $cc720565dc8e223f$exports = {};
$cc720565dc8e223f$exports = import.meta.resolve("hLVNz");


var $389913045e35d54c$exports = {};
$389913045e35d54c$exports = import.meta.resolve("TNDVm");


var $01fdac6d0ae2320e$exports = {};
$01fdac6d0ae2320e$exports = import.meta.resolve("iO9qd");


var $692865d6905ba04e$exports = {};
$692865d6905ba04e$exports = import.meta.resolve("1Ad0H");


var $84d37b386740a3e7$exports = {};
$84d37b386740a3e7$exports = import.meta.resolve("i58zp");


var $d231033b621dba1c$exports = {};
$d231033b621dba1c$exports = import.meta.resolve("7wzQf");


var $5a4c71ca66aecfcb$exports = {};
$5a4c71ca66aecfcb$exports = import.meta.resolve("9hI2A");


var $2bd5e3f730992938$exports = {};
$2bd5e3f730992938$exports = import.meta.resolve("aCdPx");


var $49a6185cc2afb601$exports = {};
$49a6185cc2afb601$exports = import.meta.resolve("5NnCH");


var $40c96ea9252b8b30$exports = {};
$40c96ea9252b8b30$exports = import.meta.resolve("4tGEG");


var $50c6e4eae57e3233$exports = {};
$50c6e4eae57e3233$exports = import.meta.resolve("a5Wm1");


var $3e742365cd33fb4c$exports = {};
$3e742365cd33fb4c$exports = import.meta.resolve("kuFTq");


var $685860b767b05a48$exports = {};
$685860b767b05a48$exports = import.meta.resolve("5XVfr");


var $dc57db150b6166d9$exports = {};
$dc57db150b6166d9$exports = import.meta.resolve("lQaSU");


var $ada1167ac08043f5$exports = {};
$ada1167ac08043f5$exports = import.meta.resolve("kRpkE");


var $11ff8a9e4d4af631$exports = {};
$11ff8a9e4d4af631$exports = import.meta.resolve("jPDyo");


var $8a145372be829907$exports = {};
$8a145372be829907$exports = import.meta.resolve("g4X4u");


var $409894ea62b269a6$exports = {};
$409894ea62b269a6$exports = import.meta.resolve("lmfY5");


var $3b79ca0b16493eb0$exports = {};
$3b79ca0b16493eb0$exports = import.meta.resolve("aS62C");


var $d6c2f900740a2ebf$exports = {};
$d6c2f900740a2ebf$exports = import.meta.resolve("cItfG");


var $376d33f9d9015190$exports = {};
$376d33f9d9015190$exports = import.meta.resolve("4UOxp");


var $e79bbbe61fcb8326$exports = {};
$e79bbbe61fcb8326$exports = import.meta.resolve("5U6Kh");


var $03e4636e58985e81$exports = {};
$03e4636e58985e81$exports = import.meta.resolve("9zzp5");


var $d1e3b1680f77f159$exports = {};
$d1e3b1680f77f159$exports = import.meta.resolve("1fCNc");


var $1c4d72c811587d7c$exports = {};
$1c4d72c811587d7c$exports = import.meta.resolve("ahNe5");


var $b1e0615993a631dd$exports = {};
$b1e0615993a631dd$exports = import.meta.resolve("kKwpZ");


var $a644c264c98d51c0$exports = {};
$a644c264c98d51c0$exports = import.meta.resolve("8NZis");


var $4a076e0c527c7460$exports = {};
$4a076e0c527c7460$exports = import.meta.resolve("a7ibI");


var $148fc91a9c7ce559$exports = {};
$148fc91a9c7ce559$exports = import.meta.resolve("5kshg");


var $5bc9e47a0ac2b2a6$exports = {};
$5bc9e47a0ac2b2a6$exports = import.meta.resolve("6foZ7");


var $91bcdc22301f746d$exports = {};
$91bcdc22301f746d$exports = import.meta.resolve("d3TIL");


var $867c7296ad370da6$exports = {};
$867c7296ad370da6$exports = import.meta.resolve("8LIwx");


var $1091199d1adb1234$exports = {};
$1091199d1adb1234$exports = import.meta.resolve("dAMW5");


var $faa834d69f877417$exports = {};
$faa834d69f877417$exports = import.meta.resolve("j3JTO");


var $9a950e936c636096$exports = {};
$9a950e936c636096$exports = import.meta.resolve("hKFKV");


var $5a3c9ddfa23de287$exports = {};
$5a3c9ddfa23de287$exports = import.meta.resolve("bsu22");


var $10fe39a8573e1fb2$exports = {};
$10fe39a8573e1fb2$exports = import.meta.resolve("17Tjp");


var $ce5b0a3807c6bee2$exports = {};
$ce5b0a3807c6bee2$exports = import.meta.resolve("brnl5");


var $2199502c2e5c0dc9$exports = {};
$2199502c2e5c0dc9$exports = import.meta.resolve("6EZRl");


var $a4f61eefafe231a0$exports = {};
$a4f61eefafe231a0$exports = import.meta.resolve("5AK8V");


var $fc1a7f7892b97695$exports = {};
$fc1a7f7892b97695$exports = import.meta.resolve("YlFSC");


var $767cae0666f03e1c$exports = {};
$767cae0666f03e1c$exports = import.meta.resolve("67j71");


var $e3ce2570e6d5d2e9$exports = {};
$e3ce2570e6d5d2e9$exports = import.meta.resolve("ij4MF");


var $0648163ffc5cc29b$exports = {};
$0648163ffc5cc29b$exports = import.meta.resolve("jQEDU");


var $b7cecdc1c0869742$exports = {};
$b7cecdc1c0869742$exports = import.meta.resolve("cdGvg");


var $2dca240d5edae7ed$exports = {};
$2dca240d5edae7ed$exports = import.meta.resolve("ghDeP");


var $b949ff3fbfaf80f7$exports = {};
$b949ff3fbfaf80f7$exports = import.meta.resolve("1bk0F");


var $e7ab7ec93a79ad08$exports = {};
$e7ab7ec93a79ad08$exports = import.meta.resolve("3C5XI");


var $f93fc4831fa57e90$exports = {};
$f93fc4831fa57e90$exports = import.meta.resolve("k6v4I");


var $2c19871254f52b79$exports = {};
$2c19871254f52b79$exports = import.meta.resolve("jVWEA");


var $9b5224d00251d0bf$exports = {};
$9b5224d00251d0bf$exports = import.meta.resolve("aixc9");


var $6f9e8c83123f5754$exports = {};
$6f9e8c83123f5754$exports = import.meta.resolve("9EFHu");


var $18073b41d969babd$exports = {};
$18073b41d969babd$exports = import.meta.resolve("8hN9m");


var $845410d444e23a3b$exports = {};
$845410d444e23a3b$exports = import.meta.resolve("dEGR7");


var $dab0077ee9fd4509$exports = {};
$dab0077ee9fd4509$exports = import.meta.resolve("40VZ2");


var $7496c80dc15859e2$exports = {};
$7496c80dc15859e2$exports = import.meta.resolve("bkJBc");


var $edec9e30029a064d$exports = {};
$edec9e30029a064d$exports = import.meta.resolve("f8rwG");


var $ed758abba807a6af$exports = {};
$ed758abba807a6af$exports = import.meta.resolve("lLY8S");


var $8b90daae2917b755$exports = {};
$8b90daae2917b755$exports = import.meta.resolve("epjB3");


var $b6f105d907723ea6$exports = {};
$b6f105d907723ea6$exports = import.meta.resolve("473bQ");


var $bc32464cc3d307f0$exports = {};
$bc32464cc3d307f0$exports = import.meta.resolve("7T9OS");


var $43a2e7a2e9d3c631$exports = {};
$43a2e7a2e9d3c631$exports = import.meta.resolve("6yPuG");


var $c6b460e1a59fe06f$exports = {};
$c6b460e1a59fe06f$exports = import.meta.resolve("kKo3f");


var $24bb1a4a86188097$exports = {};
$24bb1a4a86188097$exports = import.meta.resolve("jbOhF");


var $6904a3c327c66b6e$exports = {};
$6904a3c327c66b6e$exports = import.meta.resolve("bIS7F");


var $a670bb8babf907e7$exports = {};
$a670bb8babf907e7$exports = import.meta.resolve("fT0QH");


var $27ad3451ffc8b71b$exports = {};
$27ad3451ffc8b71b$exports = import.meta.resolve("aBksq");


var $a161eb0eab93afd2$exports = {};
$a161eb0eab93afd2$exports = import.meta.resolve("jVDLm");


var $b0f2d18d7fee5f45$exports = {};
$b0f2d18d7fee5f45$exports = import.meta.resolve("dJYo8");


var $bcb7be8d34964131$exports = {};
$bcb7be8d34964131$exports = import.meta.resolve("D8XSd");


var $357edd3cca4a564a$exports = {};
$357edd3cca4a564a$exports = import.meta.resolve("83zsU");


var $f1cc71a9b9d284d0$exports = {};
$f1cc71a9b9d284d0$exports = import.meta.resolve("hgmG6");


var $9a64698056aba36e$exports = {};
$9a64698056aba36e$exports = import.meta.resolve("72aFv");


var $4c4c2571f4afa0fe$exports = {};
$4c4c2571f4afa0fe$exports = import.meta.resolve("6vgKZ");


var $97bf78152c895926$exports = {};
$97bf78152c895926$exports = import.meta.resolve("3Nx5c");


var $f86830e515b12067$exports = {};
$f86830e515b12067$exports = import.meta.resolve("4irxv");


var $93b7b07639932132$exports = {};
$93b7b07639932132$exports = import.meta.resolve("9xPWU");


var $e3ddbe448931a325$exports = {};
$e3ddbe448931a325$exports = import.meta.resolve("haVvx");


var $5ef9c44cd0293328$exports = {};
$5ef9c44cd0293328$exports = import.meta.resolve("habdR");


var $946e0018a12491e0$exports = {};
$946e0018a12491e0$exports = import.meta.resolve("aZR9z");


var $54b491fe64c245cf$exports = {};
$54b491fe64c245cf$exports = import.meta.resolve("30q2k");


var $1c30600cc3763732$exports = {};
$1c30600cc3763732$exports = import.meta.resolve("h63ZK");


var $feb163a1b8b6371f$exports = {};
$feb163a1b8b6371f$exports = import.meta.resolve("lJnzo");


var $fa03ba05470a81ca$exports = {};
$fa03ba05470a81ca$exports = import.meta.resolve("lcUGP");


var $21d7351113cf893c$exports = {};
$21d7351113cf893c$exports = import.meta.resolve("cbwIX");


var $354ada69de04f79d$exports = {};
$354ada69de04f79d$exports = import.meta.resolve("5XQF8");


var $f7fbd04edce342ff$exports = {};
$f7fbd04edce342ff$exports = import.meta.resolve("6OzWH");


var $1a6bd46771f2130d$exports = {};
$1a6bd46771f2130d$exports = import.meta.resolve("dDrVH");


var $a401ced339b85412$exports = {};
$a401ced339b85412$exports = import.meta.resolve("aaQrk");


var $6f0ff87d2b78b940$exports = {};
$6f0ff87d2b78b940$exports = import.meta.resolve("iumGi");


var $e180806a4ea91413$exports = {};
$e180806a4ea91413$exports = import.meta.resolve("jAeql");


var $70d4a704dc2938da$exports = {};
$70d4a704dc2938da$exports = import.meta.resolve("eTXpY");


var $2491817b5349355d$exports = {};
$2491817b5349355d$exports = import.meta.resolve("8WDTO");


var $8402feb0cf400060$exports = {};
$8402feb0cf400060$exports = import.meta.resolve("4Z0Ph");


var $54f18f8bcfe36485$exports = {};
$54f18f8bcfe36485$exports = import.meta.resolve("9cXfA");


var $e91f073fa11a94a9$exports = {};
$e91f073fa11a94a9$exports = import.meta.resolve("9dQKh");


var $f15d849ac1decc6d$exports = {};
$f15d849ac1decc6d$exports = import.meta.resolve("dL7si");


var $b020b759eced8fba$exports = {};
$b020b759eced8fba$exports = import.meta.resolve("4J552");


var $5e8253ed3cbb5b4f$exports = {};
$5e8253ed3cbb5b4f$exports = import.meta.resolve("hkrUs");


var $3cc1d25adf97d3be$exports = {};
$3cc1d25adf97d3be$exports = import.meta.resolve("hEzaH");


const $fdaf2b585cf7a8ba$var$FRAME_URLS = [
    new URL($cc720565dc8e223f$exports).href,
    new URL($389913045e35d54c$exports).href,
    new URL($01fdac6d0ae2320e$exports).href,
    new URL($692865d6905ba04e$exports).href,
    new URL($84d37b386740a3e7$exports).href,
    new URL($d231033b621dba1c$exports).href,
    new URL($5a4c71ca66aecfcb$exports).href,
    new URL($2bd5e3f730992938$exports).href,
    new URL($49a6185cc2afb601$exports).href,
    new URL($40c96ea9252b8b30$exports).href,
    new URL($50c6e4eae57e3233$exports).href,
    new URL($3e742365cd33fb4c$exports).href,
    new URL($685860b767b05a48$exports).href,
    new URL($dc57db150b6166d9$exports).href,
    new URL($ada1167ac08043f5$exports).href,
    new URL($11ff8a9e4d4af631$exports).href,
    new URL($8a145372be829907$exports).href,
    new URL($409894ea62b269a6$exports).href,
    new URL($3b79ca0b16493eb0$exports).href,
    new URL($d6c2f900740a2ebf$exports).href,
    new URL($376d33f9d9015190$exports).href,
    new URL($e79bbbe61fcb8326$exports).href,
    new URL($03e4636e58985e81$exports).href,
    new URL($d1e3b1680f77f159$exports).href,
    new URL($1c4d72c811587d7c$exports).href,
    new URL($b1e0615993a631dd$exports).href,
    new URL($a644c264c98d51c0$exports).href,
    new URL($4a076e0c527c7460$exports).href,
    new URL($148fc91a9c7ce559$exports).href,
    new URL($5bc9e47a0ac2b2a6$exports).href,
    new URL($91bcdc22301f746d$exports).href,
    new URL($867c7296ad370da6$exports).href,
    new URL($1091199d1adb1234$exports).href,
    new URL($faa834d69f877417$exports).href,
    new URL($9a950e936c636096$exports).href,
    new URL($5a3c9ddfa23de287$exports).href,
    new URL($10fe39a8573e1fb2$exports).href,
    new URL($ce5b0a3807c6bee2$exports).href,
    new URL($2199502c2e5c0dc9$exports).href,
    new URL($a4f61eefafe231a0$exports).href,
    new URL($fc1a7f7892b97695$exports).href,
    new URL($767cae0666f03e1c$exports).href,
    new URL($e3ce2570e6d5d2e9$exports).href,
    new URL($0648163ffc5cc29b$exports).href,
    new URL($b7cecdc1c0869742$exports).href,
    new URL($2dca240d5edae7ed$exports).href,
    new URL($b949ff3fbfaf80f7$exports).href,
    new URL($e7ab7ec93a79ad08$exports).href,
    new URL($f93fc4831fa57e90$exports).href,
    new URL($2c19871254f52b79$exports).href,
    new URL($9b5224d00251d0bf$exports).href,
    new URL($6f9e8c83123f5754$exports).href,
    new URL($18073b41d969babd$exports).href,
    new URL($845410d444e23a3b$exports).href,
    new URL($dab0077ee9fd4509$exports).href,
    new URL($7496c80dc15859e2$exports).href,
    new URL($edec9e30029a064d$exports).href,
    new URL($ed758abba807a6af$exports).href,
    new URL($8b90daae2917b755$exports).href,
    new URL($b6f105d907723ea6$exports).href,
    new URL($bc32464cc3d307f0$exports).href,
    new URL($43a2e7a2e9d3c631$exports).href,
    new URL($c6b460e1a59fe06f$exports).href,
    new URL($24bb1a4a86188097$exports).href,
    new URL($6904a3c327c66b6e$exports).href,
    new URL($a670bb8babf907e7$exports).href,
    new URL($27ad3451ffc8b71b$exports).href,
    new URL($a161eb0eab93afd2$exports).href,
    new URL($b0f2d18d7fee5f45$exports).href,
    new URL($bcb7be8d34964131$exports).href,
    new URL($357edd3cca4a564a$exports).href,
    new URL($f1cc71a9b9d284d0$exports).href,
    new URL($9a64698056aba36e$exports).href,
    new URL($4c4c2571f4afa0fe$exports).href,
    new URL($97bf78152c895926$exports).href,
    new URL($f86830e515b12067$exports).href,
    new URL($93b7b07639932132$exports).href,
    new URL($e3ddbe448931a325$exports).href,
    new URL($5ef9c44cd0293328$exports).href,
    new URL($946e0018a12491e0$exports).href,
    new URL($54b491fe64c245cf$exports).href,
    new URL($1c30600cc3763732$exports).href,
    new URL($feb163a1b8b6371f$exports).href,
    new URL($fa03ba05470a81ca$exports).href,
    new URL($21d7351113cf893c$exports).href,
    new URL($354ada69de04f79d$exports).href,
    new URL($f7fbd04edce342ff$exports).href,
    new URL($1a6bd46771f2130d$exports).href,
    new URL($a401ced339b85412$exports).href,
    new URL($6f0ff87d2b78b940$exports).href,
    new URL($e180806a4ea91413$exports).href,
    new URL($70d4a704dc2938da$exports).href,
    new URL($2491817b5349355d$exports).href,
    new URL($8402feb0cf400060$exports).href,
    new URL($54f18f8bcfe36485$exports).href,
    new URL($e91f073fa11a94a9$exports).href,
    new URL($f15d849ac1decc6d$exports).href,
    new URL($b020b759eced8fba$exports).href,
    new URL($5e8253ed3cbb5b4f$exports).href,
    new URL($3cc1d25adf97d3be$exports).href
];
// === Image preload ===
const $fdaf2b585cf7a8ba$var$frames = new Array($fdaf2b585cf7a8ba$var$FRAME_URLS.length);
let $fdaf2b585cf7a8ba$var$imagesLoaded = 0;
$fdaf2b585cf7a8ba$var$FRAME_URLS.forEach((src, i)=>{
    const img = new Image();
    img.onload = ()=>{
        $fdaf2b585cf7a8ba$var$frames[i] = img;
        $fdaf2b585cf7a8ba$var$imagesLoaded++;
        if ($fdaf2b585cf7a8ba$var$imagesLoaded === $fdaf2b585cf7a8ba$var$FRAME_URLS.length) console.log('All Tesla frames preloaded.');
    };
    img.onerror = ()=>console.error(`Failed to load Tesla frame: ${src}`);
    img.src = src;
});
// === State machine ===
const $fdaf2b585cf7a8ba$var$STATES = {
    IDLE: 'idle',
    THINKING: 'thinking',
    SPEAKING: 'speaking'
};
let $fdaf2b585cf7a8ba$var$state = $fdaf2b585cf7a8ba$var$STATES.IDLE;
const $fdaf2b585cf7a8ba$var$teslaImage = document.getElementById('tesla-image');
function $fdaf2b585cf7a8ba$var$setState(next) {
    if ($fdaf2b585cf7a8ba$var$state === next) return;
    const prev = $fdaf2b585cf7a8ba$var$state;
    $fdaf2b585cf7a8ba$var$state = next;
    if (prev === $fdaf2b585cf7a8ba$var$STATES.SPEAKING) $fdaf2b585cf7a8ba$var$stopCycle();
    if (prev === $fdaf2b585cf7a8ba$var$STATES.THINKING) $fdaf2b585cf7a8ba$var$lightning.disable();
    if (next === $fdaf2b585cf7a8ba$var$STATES.SPEAKING) $fdaf2b585cf7a8ba$var$startCycle();
    if (next === $fdaf2b585cf7a8ba$var$STATES.THINKING) $fdaf2b585cf7a8ba$var$lightning.enable();
    if (next === $fdaf2b585cf7a8ba$var$STATES.IDLE) $fdaf2b585cf7a8ba$var$restToFirstFrame();
}
function $fdaf2b585cf7a8ba$var$restToFirstFrame() {
    if ($fdaf2b585cf7a8ba$var$frames[0]) $fdaf2b585cf7a8ba$var$teslaImage.src = $fdaf2b585cf7a8ba$var$frames[0].src;
}
// === Frame cycling (speaking) ===
const $fdaf2b585cf7a8ba$var$FPS = 24;
const $fdaf2b585cf7a8ba$var$FRAME_DURATION = 1000 / $fdaf2b585cf7a8ba$var$FPS;
let $fdaf2b585cf7a8ba$var$cycleIdx = 0;
let $fdaf2b585cf7a8ba$var$cycleRaf = null;
let $fdaf2b585cf7a8ba$var$cycleLastTs = 0;
function $fdaf2b585cf7a8ba$var$startCycle() {
    if ($fdaf2b585cf7a8ba$var$cycleRaf) return;
    $fdaf2b585cf7a8ba$var$cycleLastTs = 0;
    const tick = (ts)=>{
        if ($fdaf2b585cf7a8ba$var$state !== $fdaf2b585cf7a8ba$var$STATES.SPEAKING) {
            $fdaf2b585cf7a8ba$var$cycleRaf = null;
            return;
        }
        if (ts - $fdaf2b585cf7a8ba$var$cycleLastTs >= $fdaf2b585cf7a8ba$var$FRAME_DURATION) {
            const f = $fdaf2b585cf7a8ba$var$frames[$fdaf2b585cf7a8ba$var$cycleIdx];
            if (f) $fdaf2b585cf7a8ba$var$teslaImage.src = f.src;
            $fdaf2b585cf7a8ba$var$cycleIdx = ($fdaf2b585cf7a8ba$var$cycleIdx + 1) % $fdaf2b585cf7a8ba$var$FRAME_URLS.length;
            $fdaf2b585cf7a8ba$var$cycleLastTs = ts;
        }
        $fdaf2b585cf7a8ba$var$cycleRaf = requestAnimationFrame(tick);
    };
    $fdaf2b585cf7a8ba$var$cycleRaf = requestAnimationFrame(tick);
}
function $fdaf2b585cf7a8ba$var$stopCycle() {
    if ($fdaf2b585cf7a8ba$var$cycleRaf) cancelAnimationFrame($fdaf2b585cf7a8ba$var$cycleRaf);
    $fdaf2b585cf7a8ba$var$cycleRaf = null;
    $fdaf2b585cf7a8ba$var$cycleIdx = 0;
}
// === Lightning overlay (thinking state) ===
//
// Bolts are generated via midpoint-displacement: recursively split a line
// segment, jittering each midpoint, until a jagged path emerges. Each bolt
// fades over a few frames so a steady stream of new bolts produces the
// crackle effect. Drawn with a glow via shadowBlur in the line-art palette.
class $fdaf2b585cf7a8ba$var$LightningOverlay {
    constructor(parent){
        this.canvas = document.createElement('canvas');
        this.canvas.style.cssText = 'position:absolute;inset:0;pointer-events:none;mix-blend-mode:screen;';
        parent.style.position = parent.style.position || 'relative';
        parent.appendChild(this.canvas);
        this.ctx = this.canvas.getContext('2d');
        this.bolts = [];
        this.raf = null;
        this.parent = parent;
        this.resize();
        window.addEventListener('resize', ()=>this.resize());
    }
    resize() {
        const rect = this.parent.getBoundingClientRect();
        const dpr = window.devicePixelRatio || 1;
        this.canvas.width = rect.width * dpr;
        this.canvas.height = rect.height * dpr;
        this.canvas.style.width = rect.width + 'px';
        this.canvas.style.height = rect.height + 'px';
        this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        this.w = rect.width;
        this.h = rect.height;
    }
    enable() {
        if (this.raf) return;
        this.bolts = [];
        const tick = ()=>{
            if ($fdaf2b585cf7a8ba$var$state !== $fdaf2b585cf7a8ba$var$STATES.THINKING) {
                this.raf = null;
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                this.bolts = [];
                return;
            }
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            // Probabilistically spawn new bolts (cap concurrent count).
            if (Math.random() < 0.18 && this.bolts.length < 4) this.bolts.push(this.makeBolt());
            this.bolts = this.bolts.filter((b)=>{
                b.life -= 1;
                if (b.life <= 0) return false;
                this.drawBolt(b);
                return true;
            });
            this.raf = requestAnimationFrame(tick);
        };
        this.raf = requestAnimationFrame(tick);
    }
    disable() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.bolts = [];
    }
    makeBolt() {
        // Origin lies on a circle near the top of the head; bolts radiate
        // outward through the upper hemisphere.
        const rect = $fdaf2b585cf7a8ba$var$teslaImage.getBoundingClientRect();
        const parentRect = this.parent.getBoundingClientRect();
        const cx = rect.left - parentRect.left + rect.width / 2;
        const cy = rect.top - parentRect.top + rect.height * 0.32;
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 0.9;
        const innerR = Math.min(rect.width, rect.height) * 0.32;
        const outerR = innerR + Math.min(rect.width, rect.height) * (0.18 + Math.random() * 0.3);
        const start = {
            x: cx + Math.cos(angle) * innerR,
            y: cy + Math.sin(angle) * innerR
        };
        const end = {
            x: cx + Math.cos(angle) * outerR,
            y: cy + Math.sin(angle) * outerR
        };
        const maxLife = 7 + Math.floor(Math.random() * 6);
        return {
            points: this.midpointDisplace(start, end, 5, 22),
            life: maxLife,
            maxLife: maxLife,
            // Optional small fork at a random midpoint.
            fork: Math.random() < 0.4 ? this.makeFork(start, end) : null
        };
    }
    makeFork(start, end) {
        const t = 0.4 + Math.random() * 0.3;
        const mid = {
            x: start.x + (end.x - start.x) * t,
            y: start.y + (end.y - start.y) * t
        };
        const dx = end.x - start.x;
        const dy = end.y - start.y;
        const len = Math.hypot(dx, dy) * (0.4 + Math.random() * 0.3);
        const ang = Math.atan2(dy, dx) + (Math.random() < 0.5 ? -1 : 1) * (0.5 + Math.random() * 0.4);
        const tip = {
            x: mid.x + Math.cos(ang) * len,
            y: mid.y + Math.sin(ang) * len
        };
        return this.midpointDisplace(mid, tip, 4, 14);
    }
    midpointDisplace(a, b, depth, jitter) {
        if (depth === 0) return [
            a,
            b
        ];
        const mid = {
            x: (a.x + b.x) / 2 + (Math.random() - 0.5) * jitter,
            y: (a.y + b.y) / 2 + (Math.random() - 0.5) * jitter
        };
        const left = this.midpointDisplace(a, mid, depth - 1, jitter * 0.6);
        const right = this.midpointDisplace(mid, b, depth - 1, jitter * 0.6);
        return [
            ...left.slice(0, -1),
            ...right
        ];
    }
    drawBolt(b) {
        const t = b.life / b.maxLife;
        const alpha = t;
        // Cyan/green palette to match the line art (rgb 121, 235, 187).
        this.ctx.shadowColor = 'rgba(121, 235, 187, 0.95)';
        this.ctx.shadowBlur = 14;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';
        this.ctx.strokeStyle = `rgba(170, 255, 215, ${alpha})`;
        this.ctx.lineWidth = 1.6;
        this.strokePath(b.points);
        if (b.fork) {
            this.ctx.strokeStyle = `rgba(170, 255, 215, ${alpha * 0.7})`;
            this.ctx.lineWidth = 1.1;
            this.strokePath(b.fork);
        }
    }
    strokePath(points) {
        this.ctx.beginPath();
        this.ctx.moveTo(points[0].x, points[0].y);
        for(let i = 1; i < points.length; i++)this.ctx.lineTo(points[i].x, points[i].y);
        this.ctx.stroke();
    }
}
const $fdaf2b585cf7a8ba$var$lightning = new $fdaf2b585cf7a8ba$var$LightningOverlay(document.getElementById('image-container'));
// === Cursor parallax + idle breathing ===
//
// `transform` is a single CSS property, so parallax and breathing must be
// composed into one string per frame. We lerp toward the cursor target so
// motion is smooth even when the mouse moves discretely.
let $fdaf2b585cf7a8ba$var$cursorTargetX = 0;
let $fdaf2b585cf7a8ba$var$cursorTargetY = 0;
let $fdaf2b585cf7a8ba$var$cursorX = 0;
let $fdaf2b585cf7a8ba$var$cursorY = 0;
const $fdaf2b585cf7a8ba$var$PARALLAX_DEG = 2; // subtle, per user choice.
document.addEventListener('mousemove', (e)=>{
    $fdaf2b585cf7a8ba$var$cursorTargetX = e.clientX / window.innerWidth - 0.5; // -0.5..0.5
    $fdaf2b585cf7a8ba$var$cursorTargetY = e.clientY / window.innerHeight - 0.5;
});
let $fdaf2b585cf7a8ba$var$breathPhase = 0;
function $fdaf2b585cf7a8ba$var$presenceLoop() {
    $fdaf2b585cf7a8ba$var$cursorX += ($fdaf2b585cf7a8ba$var$cursorTargetX - $fdaf2b585cf7a8ba$var$cursorX) * 0.06;
    $fdaf2b585cf7a8ba$var$cursorY += ($fdaf2b585cf7a8ba$var$cursorTargetY - $fdaf2b585cf7a8ba$var$cursorY) * 0.06;
    $fdaf2b585cf7a8ba$var$breathPhase += 0.013;
    const breathScale = 1 + Math.sin($fdaf2b585cf7a8ba$var$breathPhase) * 0.006;
    const ry = $fdaf2b585cf7a8ba$var$cursorX * $fdaf2b585cf7a8ba$var$PARALLAX_DEG;
    const rx = -$fdaf2b585cf7a8ba$var$cursorY * $fdaf2b585cf7a8ba$var$PARALLAX_DEG;
    $fdaf2b585cf7a8ba$var$teslaImage.style.transform = `perspective(900px) rotateY(${ry.toFixed(3)}deg) rotateX(${rx.toFixed(3)}deg) scale(${breathScale.toFixed(4)})`;
    requestAnimationFrame($fdaf2b585cf7a8ba$var$presenceLoop);
}
$fdaf2b585cf7a8ba$var$teslaImage.style.willChange = 'transform';
requestAnimationFrame($fdaf2b585cf7a8ba$var$presenceLoop);
// === Bridge to existing events ===
document.addEventListener('textUpdate', (event)=>{
    const { sentenceEnded: sentenceEnded } = event.detail;
    $fdaf2b585cf7a8ba$var$setState(sentenceEnded ? $fdaf2b585cf7a8ba$var$STATES.IDLE : $fdaf2b585cf7a8ba$var$STATES.SPEAKING);
});
document.addEventListener('assistantThinking', ()=>{
    $fdaf2b585cf7a8ba$var$setState($fdaf2b585cf7a8ba$var$STATES.THINKING);
});


//# sourceMappingURL=repo.60317e1e.js.map
